import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {PaZoneService} from '@catmodules/models/pa-zone/services/pa-zone.service';

const publicComponents = [];

const imports = [
  CommonModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [PaZoneService];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class PaZoneModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/pa-zone/pa-zone.module.ts